/** @jsx jsx */
// @ts-check
import { Box, Button, Flex, Text } from '@bottlebooks/gatsby-theme-base';
import Dialog from '@reach/dialog';
import { jsx } from 'theme-ui';
import { Trans } from '@lingui/macro';
import { AuthService } from 'gatsby-theme-auth0';

/**
 * A dialog box for sharing products.
 * Used in ShareProductAction, ShareProductListAction and ShareShareListAction.
 * @param {object} props
 * @param {() => void} props.onCancel
 * }
 * @returns {React.ReactElement}
 */
export default function AuthorizationModal({ onCancel, ...rest }) {
  return (
    <Dialog
      isOpen
      onDismiss={onCancel}
      aria-label="Book a meeting"
      sx={{
        borderRadius: 'default',
        '&&': {
          width: ['90vw', '80vw', '75vw', 768],
          padding: 2,
        },
      }}
      {...rest}
    >
      <Box>
        <Flex direction="column" sx={{ alignItems: 'center' }}>
          <Text sx={{ marginY: 3 }}>
            <Trans>Login to unlock all the features on this site.</Trans>
          </Text>
          <Button
            onClick={AuthService.login}
            variant="primary"
            sx={{ paddingX: 4, paddingY: 2, alignItems: 'center' }}
            {...rest}
          >
            Login
          </Button>
          <Flex sx={{ paddingY: 3, width: '100%' }}>
            <Box
              sx={{
                borderBottom: 2,
                height: 16,
                borderColor: 'borderSecondary',
                width: '45%',
                marginX: 3,
              }}
            />
            <Text>
              <Trans>or</Trans>
            </Text>
            <Box
              sx={{
                borderBottom: 2,
                height: 16,
                borderColor: 'borderSecondary',
                width: '45%',
                marginX: 3,
              }}
            />
          </Flex>
          <Text sx={{ marginY: 3 }}>
            <Trans>Don't have an account?</Trans>
          </Text>
          <Button
            onClick={AuthService.login}
            variant="outline"
            sx={{
              paddingX: 4,
              paddingY: 2,
              marginBottom: 3,
              alignItems: 'center',
            }}
            {...rest}
          >
            Register
          </Button>
        </Flex>
      </Box>
    </Dialog>
  );
}
